<template>
     <b-dropdown
            id="dropdown-form"
            ref="downdownItem"
            class="filter-dropdown"
            size="sm"
            :text="filterText"
            :toggle-class="filterClass"
          >
            <b-dropdown-form>
              <b-form-textarea
                class="mb-2"
                id="textarea"
                :placeholder="$t('SEARCH')"
                @input="updateInput"
                v-model="info"
                rows="3"
                max-rows="6"
              ></b-form-textarea>
            </b-dropdown-form>
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-form>	
                <b-button class="no-border" size="sm"
                @click="closeFilter"
                >{{ $t("CLOSE") }}</b-button>
              <b-button class="no-border" size="sm"
              v-if="info.length != 0"
              @click="clearFilter"
              >{{ $t("CLEAR") }}</b-button>
            </b-dropdown-form>

          </b-dropdown>
  </template>
<script>
export default {
  props: ["value","title"],
  data() {
    return {      
      info: this.value
    };
  },
  methods: {
    closeFilter() {
      this.$refs.downdownItem.visible = false;
    },
    clearFilter() {
      this.info = "";
      this.updateInput();
    },
    updateInput () {
      this.$emit('input', this.info)
    },
    getName()
    {
      
    }
  },
  computed: {
    filterItems(){
       return this.filterData.filter( (item) => {
          return (item.id.toLowerCase().indexOf(this.searchText.toLowerCase()) != -1) || (item.text.toLowerCase().indexOf(this.searchText.toLowerCase()) != -1)
      });
    },
    filterClass() {
      if (this.info != "") {
        return ["filter-selected", "no-border"];
      } else {
        return ["no-border"];
      }
    },
    filterText() {      
      if(this.info.length > 12)
      {
        return this.title + ": " + this.info.substr(0,10) + "..";
      }else{
        return this.title + ": " + this.info;
      }
    }
  },
  mounted(){    
  }
};
</script>
<style></style>
